import styled from 'styled-components'

const QuestionListUi = styled.div`
  padding-left: 30px;
`

export default QuestionListUi
